<template>
  <!-- <div class="competitor-detail" :data-type="state"> -->
  <div class="competitor-detail" :data-type="type" v-if="dataList.length > 0">
    <button :title="titleAdd" @click="opened = true" v-if="!id && !opened">
      <i class="el-icon-circle-plus-outline" />
    </button>
    <button :title="titleDel" @click="del" v-if="id">
      <i class="el-icon-delete" />
    </button>
    <span v-if="value" :title="value.name" @click="opened = true">{{ value.shortname }}</span>
    <select @change="save" v-if="opened" @blur="opened = false">
      <option v-for="item in dataList" :key="item.id" :title="item.name" :data-value="item.id" :selected="id === item.id">
        {{ item.shortname + ' - ' + item.name }}
      </option>
    </select>
    <button title="Fermer la liste" @click="opened = false" v-if="opened">
      <i class="el-icon-close" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SportGamesCompetitorDetail',
  props: {
    parentId: Number,
    id: Number,
    type: String,
    parent: String,
    disciplineId: Number
  },
  data () {
    return {
      opened: false
    }
  },
  computed: {
    titleAdd () { return 'Ajouter un nouveau "' + this.type + '"' },
    titleDel () { return 'Supprimer le ""' + this.type + '"' },
    dataList () {
      let values = null
      switch (this.type) {
        case 'record':
          values = this.$store.getters['Sport/CompetitorRecord/list']
          break
        case 'status':
          values = this.$store.getters['Sport/CompetitorStatus/list']
          break
        case 'qualify':
          values = this.$store.getters['Sport/CompetitorQualify/getByDiscipline'](this.disciplineId)
          break
      }
      return values
    },
    value () {
      let value = null
      if (this.id) {
        switch (this.type) {
          case 'record':
            value = this.$store.getters['Sport/CompetitorRecord/get'](this.id)
            break
          case 'status':
            value = this.$store.getters['Sport/CompetitorStatus/get'](this.id)
            break
          case 'qualify':
            value = this.$store.getters['Sport/CompetitorQualify/get'](this.id)
            break
        }
      }
      return value
    }
  },
  methods: {
    save (event) {
      const select = event.target
      const value = select.options[select.selectedIndex].getAttribute('data-value')
      const data = { id: this.parentId }
      data[this.type + 'Id'] = value
      console.log('Sport/' + this.parent + '/put')
      this.$store.dispatch('Sport/' + this.parent + '/put', data)
      this.opened = false
    },
    del () {
      const data = { id: this.parentId }
      data[this.type + 'Id'] = null
      this.$store.dispatch('Sport/' + this.parent + '/put', data)
    }
  }
}
</script>

<style scoped>
  .competitor-detail{
    display:flex;
    padding:0 10px;
    margin-left:10px;
    border-radius:4px;
    align-items:center;
    height:30px;
  }
  .competitor-detail[data-type="record"]{
    background-color:#e6a23c
  }
  .competitor-detail[data-type="qualify"]{
    background-color:#67c23a
  }
  .competitor-detail[data-type="status"]{
    background-color:#f56c6c
  }
  .competitor-detail > button{
    display:flex;
    align-items:center;
    justify-content:center;
    background-color:transparent;
    border:none;
    cursor:pointer;
    color:white;
    width:20px;
  }
  .competitor-detail > button:hover{
    font-size:larger
  }
  .competitor-detail > select{
    max-width:200px
  }
  .competitor-detail > span{
    font-weight:bold;
    color:white
  }
</style>
